export default "__VITE_ASSET__5tyk8HQC__"